import React from 'react';
import { formata, distanciaAteHoje, mesesExtenso } from '../../../Helpers/date';
import { mascCPF, mascCEP, mascPIS, mascTelefone } from '../../../Helpers/mascara';
import styled from 'styled-components';
import Foto from '../Foto';
import InfoBox from '../InfoBox';
import InfoBoxSalario from '../InfoBoxSalario';
import {
  tb_Categoria,
  tb_Vinculo,
  tb_TipoEndereco,
  tb_EstadoCivil,
  tb_Sexo,
  tb_GrauInstrucao,
} from '../tabelas';


const MainGrid = styled.div`
  display: grid;
  width: 700px;
  margin: 0 auto;
  grid-template-columns: 350px 350px;
  grid-template-rows: 110px auto;
  grid-template-areas:
    "header  header"
    "pessoal ender "
    "pessoal docs"
    "trab    trab";
`

const FuncionarioCard = styled.div`
  grid-area: header;
  margin: 4px;
  padding-bottom: 14px;
  border: 1px solid #ccc;
  border-radius: 3px;
  display: grid;
  grid-template-columns: 150px 550px;
  grid-template-rows: auto auto;
  grid-template-areas:
    "foto main"
    "foto main";
`

const MainBox = styled.span`
  grid-area: main;
  display: flex;
  flex-direction: column;
  justify-content: center;
  & > div {
    font-size: 14px;
    display: flex;
  }
  & > div > .fas {
    margin-left: 3px;
    margin-bottom: 2px;
    width: 30px;
    text-align: center;
  }
  & > div:first-child {
    display: inline-block;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  & .codigo {
    margin-left: 5px;
    font-size: 12px;
    color: gray;
  }
`

function readTable(cod, table) {
  let out = table[cod] || '?'
  return out
}

const Painel = styled.div`
  ${props => props.area ? `grid-area: ${props.area}` : ""};
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 10px;
  margin: 10px 4px;
  & > .header {
    background: transparent;
    margin-top: -18px;
    margin-bottom: 5px;
  }
  & > .header > span {
    background: white;
    padding: 0px 10px;
    font-size: 14px;
    color: #555;
  }
`

const PainelTrab = styled.div`
  display: grid;
  grid-template-columns: 160px auto;
  grid-template-areas:
    "col1   col2"
    "footer footer";
`

function ProcessaReajustes (f) {
  const {sDatas, sMotivos, sPerc, sDiff} = f.Reajustes
  let dataReajuste = sDatas && (
    sDatas[sDatas.length - 1]
  ) || null
  let motivosReajuste = sMotivos && sMotivos.join(", ") || ""
  let percentReajuste = sPerc && sPerc.toLocaleString("pt-BR", {maximumFractionDigits:1}) + " %" || ""
  return { dataReajuste, motivosReajuste, percentReajuste }
}

function Funcionarios_Detalhes (props) {
  let { funcionarios, empregadoId, dptosById } = props;
  if (!funcionarios || !empregadoId) return null;
  let f = funcionarios.find(e => e.Codigo == empregadoId)
  let reajustes = ProcessaReajustes(f);
  return (
    <MainGrid>
      <FuncionarioCard>
        <Foto src={f.Foto} />
        <MainBox>
          <div>
            {f.Nome}
            <span className="codigo">
              [{empregadoId}]
            </span>
          </div>
          <div>
            <i className={`fas fa-users`}></i>
            {dptosById[f.DptoID].Nome}
          </div>
          <div>
            <i className={`fas fa-id-badge`}></i>
            {f.Cargo}
          </div>
        </MainBox>
      </FuncionarioCard>
      <Painel area='trab'>
        <div className="header">
          <span>Trabalhista</span>
        </div>
        <PainelTrab>
          <div style={{gridArea: 'col1'}}>
            <InfoBox
              iconName="sign-in-alt"
              label={"Admissão"}
              value={formata(f.Admissao)}
              details={distanciaAteHoje(f.Admissao)}
            />
            <InfoBox
              iconName="umbrella-beach"
              label={"Vencimento Férias"}
              value={formata(f.VencimentoFerias)}
              details={distanciaAteHoje(f.VencimentoFerias)}
            />
            <InfoBoxSalario f={f} />
          </div>
          <div style={{gridArea: 'col2'}}>
            <InfoBox
              iconName="book"
              label={"Categoria"}
              value={readTable(f.Categoria, tb_Categoria)}
              details={readTable(f.VinculoEmpregaticio, tb_Vinculo)}
            />
            <InfoBox
              label={"Jornada"}
              value={f.NomeJornada}
              iconName="clock"
              iconVariation="far"
              details={`Horas/mês: ${parseFloat(f.HorasMes)}`}
            />
            <InfoBox
              iconName="greater-than"
              label={"Reajustes 12 meses"}
              value={reajustes.percentReajuste || "-"}
              details={reajustes.motivosReajuste}
            />
          </div>
          <div style={{gridArea: 'footer'}}>
            <InfoBox
              iconName="users"
              label={"Sindicato"}
              value={f.Sindicato}
              details={obtemDetalhesSindicato(f)}
            />
          </div>
        </PainelTrab>
      </Painel>
      <Painel area='ender'>
        <div className="header">
          <span>Endereço</span>
        </div>
        <div>
          {readTable(f.TipoEndereco, tb_TipoEndereco).toUpperCase()}
          {' '}
          {f.Endereco}
          {f.NumEndereco ? `, ${f.NumEndereco}` : ""}
          {f.Complemento ? ` ${f.Complemento}` : ""}
        </div>
        <div>
          {f.Bairro} - {f.Cidade} / {f.UF}
        </div>
        <div>CEP: {mascCEP(f.CEP)}</div>
      </Painel>
      <Painel area='docs'>
        <div className="header">
          <span>Documentos</span>
        </div>
        <div><b>RG: </b> {f.RG}</div>
        <div><b>PIS: </b> {mascPIS(f.PIS)}</div>
        <div><b>CPF: </b> {mascCPF(f.CPF)}</div>
        <div><b>Carteira de Trabalho: </b> {f.CarteiraTrabalho}</div>
      </Painel>
      <Painel area='pessoal'>
        <div className="header">
          <span>Dados pessoais</span>
        </div>
        <div><b>Telefone: </b> {obtemTelefone(f, 'Telefone')}</div>
        <div><b>Celular: </b> {obtemTelefone(f, 'Celular')}</div>
        <div><b>E-mail: </b> {lerCampo(f, 'Email')}</div>
        <div><b>Data Nascimento: </b> {formata(f.DataNascimento)}</div>
        <div><b>Local Nascimento: </b> {f.LocalNascimento}/{f.LocalNascimentoUF}</div>
        <div><b>Sexo: </b> {readTable(f.Sexo, tb_Sexo)}</div>
        <div><b>Estado Civil: </b> {readTable(f.EstadoCivil, tb_EstadoCivil)}</div>
        <div><b>Nacionalidade: </b> {f.Nacionalidade}</div>
        <div><b>Grau de Instrução: </b> {readTable(f.GrauInstrucao, tb_GrauInstrucao)}</div>
      </Painel>


    </MainGrid>
  )
}

const EmBranco = styled.span`
  font-style: italic;
`

const lerCampo = (f, str) => {
  let campo = f[str];
  if (!campo) return <EmBranco>{"<Em branco>"}</EmBranco>;
  return campo;
}

const obtemTelefone = (f, str) => {
  let Telefone = mascTelefone(f[str])
  let DDDTelefone = f["DDD"+str]
  if (!Telefone) return <EmBranco>{"<Em branco>"}</EmBranco>
  if (!DDDTelefone) return Telefone
  return `(${DDDTelefone}) ${Telefone}`
}

const obtemDetalhesSindicato = f => {
  const { SindicatoTelefone, SindicatoMesBase } = f;
  return (
    <>
    {SindicatoTelefone && (
      <>  
        {"Telefone: "}
        {SindicatoTelefone}
        &nbsp;&nbsp;&nbsp;{'\u2022'}&nbsp;&nbsp;&nbsp;
      </>
    )}
    {SindicatoMesBase && (
      <>
        {"Mês-Base: "}
        {mesesExtenso[parseInt(SindicatoMesBase)].toUpperCase()}
      </>
    )}
    </>
  )
}

export default Funcionarios_Detalhes;
